import TEMP_getInitialProps from "@components/VirtualCare/TEMP_getInitialProps";
import {useRouter} from "next/router";
import {useTranslation} from "ni18n";
import React from "react";
import Download from "src/components/v5/Reason/Download";
import TestimonialSlider from "src/components/v5/TestimonialSlider";
import {useTypedSelector} from "src/store";

import {vcData} from "../components/_common/_constants";
import Insurances from "../components/v5/Insurances";
import Layout from "../components/v5/Layout";
import Hero from "../components/v5/VirtualCare/Hero";
import Reasons from "../components/v5/VirtualCare/Reasons";
import Services from "../components/v5/VirtualCare/Services";
import {SpecialtyId} from "../constants/specialtyIds";

const currentSpecialtyId = SpecialtyId.VIRTUAL_URGENT_CARE;

const VirtualCare = () => {
  const i18n = useTranslation();
  const {imgExt, pageLoaded, reasons = []} = useTypedSelector(({config}) => config);
  const {pathname} = useRouter();

  return (
    <Layout
      pageTitle={i18n.t("Talk to a Doctor Online | Virtual Care at Carbon Health")}
      pageDescription={i18n.t(
        "From preventive to urgent care and everything in between, our virtual care providers are here for you. Connect with a doctor online today.",
      )}
      pageImage="virtual-care"
      navStartTransparent={false}
      style={{
        "--brandColor": vcData[currentSpecialtyId].color,
        "--brandColorDarken": vcData[currentSpecialtyId].darker,
        "--brandColorDarken2": vcData[currentSpecialtyId].darker2,
        "--hero": `linear-gradient(90deg, rgba(53, 56, 61, 0.8) 0%, rgba(70, 72, 73, 0) 75%), url(/static/img/v5/${vcData[currentSpecialtyId].hero}.${imgExt})`,
      }}
    >
      <Hero pathname={pathname} currentSpecialtyId={currentSpecialtyId} />
      <Services />
      <Download trackingLabel={currentSpecialtyId} />
      <Reasons {...{reasons, currentSpecialtyId, pageLoaded}} />
      <Insurances />
      <TestimonialSlider />
    </Layout>
  );
};

VirtualCare.getInitialProps = TEMP_getInitialProps;

export default VirtualCare;
